import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { useNavigate } from 'react-router'
import { PopupAction } from '../../../../common/popup/PopupAction'
import { resetStoreHeaderCompanyAnalysis } from '../../../../companyAnalysis/common/header/companyInfo/store/slice'
import { COMPONENTS } from '../../../../routers/constants'
import { changeDataKeepSetting, setBlankTemplate } from './store/slice'

const PopupKeepSetting = ({ isShow, setIsShow, data }) => {
  const dispatch = useDispatch()

  const navigate = useNavigate()

  const redirectToDynamicReport = (_, isKeep) => {
    dispatch(resetStoreHeaderCompanyAnalysis())
    if (isKeep) {
      navigate(
        `${COMPONENTS.dynamicReport.route}?organizationId=${data.organizationId}`,
      )
      return
    }

    dispatch(setBlankTemplate())
    navigate(`${COMPONENTS.dynamicReport.route}`)
  }

  const handleSubmit = () => {
    dispatch(changeDataKeepSetting(data))
    redirectToDynamicReport(false, true)
  }

  return (
    <PopupAction
      isShow={isShow}
      title="dynamicReport.KEEP_SETTING_TITLE"
      btnSubmit={{
        label: 'dynamicReport.YES',
        isI18n: true,
        event: handleSubmit,
      }}
      btnCancel={{
        label: 'dynamicReport.NO',
        isI18n: true,
        event: redirectToDynamicReport,
      }}
      handleClose={() => setIsShow(false)}
    >
      <Translate value="dynamicReport.KEEP_SETTING_CONTENT" />
    </PopupAction>
  )
}

PopupKeepSetting.propTypes = {
  isShow: PropTypes.bool.isRequired,
  setIsShow: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
}

export default PopupKeepSetting
